import React, { useState } from "react";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Tag } from "primereact/tag";
import { FaRegCalendarAlt } from "react-icons/fa";
import { useTheme } from "../../context/ThemeContext";

/**
 * @param {{
 *   meetingInfo: {
 *     title: string;
 *     date: string;
 *     time: string;
 *     organizer?: string;
 *     reminder?: string;
 *     selectedCustomers?: any[];
 *     selectedGroups?: any[];
 *   };
 *   templateInfo: {
 *     reminder?: { finalPreview?: string };
 *     confirmation?: { finalPreview?: string };
 *     booking?: { finalPreview?: string };
 *
 *   };
 *
 *   onBack: () => void;
 *   onSchedule: () => void;
 * }}
 */

export default function Step3Review({
  meetingInfo = {},
  templateInfo = {},
  coverImage: initialCoverImageFromProps = null,
  onBack,
  onSchedule,
}) {
  const [coverImage, setCoverImage] = useState(initialCoverImageFromProps);
  const { theme } = useTheme();
  const meeting = {
    title: meetingInfo.title || "-",
    datetime: `${meetingInfo.date || "-"}, ${meetingInfo.time || "-"}`,
    customers:
      ((meetingInfo.selectedCustomers || []).length || 0) +
      ((meetingInfo.selectedGroups || []).length || 0),
    organizer: meetingInfo.organizer || "-",
    reminder: `${meetingInfo.reminder || "-"} min Before`,
    templates: {
      reminder: templateInfo.reminder || null,
      confirmation: templateInfo.confirmation || null,
      booking: templateInfo.booking || null,
    },
  };

  /* ——— Shared styles ——— */
  const cardStyle = {
    marginBottom: "1.25rem",
    border: "1px solid #ddd",
    borderRadius: "6px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
    padding: "1.25rem",
  };
  const headerRow = (iconJSX, heading, editable = false) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        marginBottom: "1rem",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {iconJSX}
        <h3 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>{heading}</h3>
      </div>
      {editable && (
        <Button
          icon="pi pi-pencil"
          label="Edit"
          text
          className="p-button-sm"
          style={{
            border: "1px solid #d1d5db",
            borderRadius: 19,
            padding: "0.25rem 0.75rem",
            color: "#6b7280",
          }}
          onClick={onBack}
        />
      )}
    </div>
  );

  return (
    <div
      style={{
        maxWidth: "839px",
        margin: "2rem 1rem",
        padding: 0,
      }}
    >
      {/* ───── Meeting Details ───── */}
      <Card
        style={cardStyle}
        header={headerRow(
          <FaRegCalendarAlt size={18} color="#3B82F6" />,
          "Meeting Details",
          true
        )}
      >
        {[
          { label: "Meeting title:", value: meeting.title },
          { label: "Date & time:", value: meeting.datetime },
          {
            label: "Customers & Groups:",
            value: (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "0.5rem",
                  justifyContent: "flex-end",
                }}
              >
                {(meetingInfo.selectedCustomers || [])
                  .slice(0, 3)
                  .map((cust) => (
                    <Tag
                      key={cust.id || cust._id}
                      value={cust.name || "Unnamed"}
                      severity="info"
                      style={{ background: "#EFF6FF", color: "#2563EB" }}
                    />
                  ))}

                {meetingInfo.selectedCustomers?.length > 3 && (
                  <Tag
                    value={`+${meetingInfo.selectedCustomers.length - 3}`}
                    severity="info"
                    style={{
                      background: "#DBEAFE",
                      color: "#1D4ED8",
                      fontWeight: "bold",
                    }}
                  />
                )}

                {(meetingInfo.selectedGroups || []).map((group) => (
                  <Tag
                    key={group.id || group._id}
                    value={group.groupName || "Unnamed Group"}
                    severity="success"
                    style={{ background: "#ECFDF5", color: "#047857" }}
                  />
                ))}
              </div>
            ),
          },
          { label: "Organizer Name:", value: meeting.organizer },
          { label: "Reminder Time:", value: meeting.reminder },
        ].map((row, idx, arr) => (
          <div
            key={idx}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0.8rem 0",
              borderBottom:
                idx !== arr.length - 1 ? "1px solid #e5e7eb" : "none",
              fontSize: 14,
            }}
          >
            <span style={{ color: "#374151" }}>{row.label}</span>
            <span style={{ fontWeight: 600, color: "#111827" }}>
              {row.value}
            </span>
          </div>
        ))}
      </Card>
      {/* {(meetingInfo.selectedCustomers?.length ||
        meetingInfo.selectedGroups?.length) > 0 && (
        <Card
          style={cardStyle}
          header={headerRow(
            <FaRegCalendarAlt size={18} color="#3B82F6" />,
            "Participants",
            true
          )}
        >
          {meetingInfo.selectedCustomers?.length > 0 && (
            <div style={{ marginBottom: "1rem" }}>
              <h4 style={{ margin: 0, fontSize: 14, color: "#4B5563" }}>
                Customers:
              </h4>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "0.5rem",
                  marginTop: 8,
                }}
              >
                {meetingInfo.selectedCustomers.map((cust) => (
                  <Tag
                    key={cust.id || cust._id}
                    value={cust.name || "Unnamed"}
                    severity="info"
                    style={{ background: "#EFF6FF", color: "#2563EB" }}
                  />
                ))}
              </div>
            </div>
          )}

          {meetingInfo.selectedGroups?.length > 0 && (
            <div>
              <h4 style={{ margin: 0, fontSize: 14, color: "#4B5563" }}>
                Groups:
              </h4>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "0.5rem",
                  marginTop: 8,
                }}
              >
                {meetingInfo.selectedGroups.map((group) => (
                  <Tag
                    key={group.id || group._id}
                    value={group.groupName || "Unnamed Group"}
                    severity="success"
                    style={{ background: "#ECFDF5", color: "#047857" }}
                  />
                ))}
              </div>
            </div>
          )}
        </Card>
      )} */}

      {/* {coverImage && (
        <Card
          style={cardStyle}
          header={headerRow(
            <img
              src="/logo192.png" // replace with your actual logo or icon if needed
              alt="Cover"
              style={{ width: 20, height: 20 }}
            />,
            "Cover Image",
            true
          )}
        >
          <div
            style={{
              borderRadius: "0.75rem",
              overflow: "hidden",
              border: `1px solid ${theme.border}`,
              marginBottom: "0.75rem",
              maxWidth: "100%",
            }}
          >
            <img
              src={coverImage}
              alt="Meeting Cover"
              style={{
                width: "100%",
                height: "180px",
                objectFit: "cover",
              }}
            />
          </div>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <label
              htmlFor="change-cover"
              style={{
                fontSize: "0.8rem",
                color: theme.primary,
                cursor: "pointer",
                fontWeight: 500,
                textDecoration: "underline",
              }}
            >
              Change Image
            </label>

            <a
              href={coverImage}
              download="meeting_cover.jpg"
              style={{
                fontSize: "0.8rem",
                color: theme.primary,
                fontWeight: 500,
                textDecoration: "underline",
              }}
            >
              Download
            </a>
          </div>

          <input
            id="change-cover"
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={(e) => {
              const file = e.target.files[0];
              if (file) {
                const reader = new FileReader();
                reader.onloadend = () => {
                  setCoverImage(reader.result);
                };
                reader.readAsDataURL(file);
              }
            }}
          />
        </Card>
      )} */}

      {/* ───── Selected Templates ───── */}
      <Card
        style={cardStyle}
        header={headerRow(
          <FaRegCalendarAlt size={18} color="#3B82F6" />,
          "Selected Template",
          true
        )}
      >
        {[
          {
            key: "reminder",
            title: "Reminder",
            badgeColor: "#d97706",
            badgeBg: "#fff7ed",
            borderColor: "teal",
          },
          {
            key: "confirmation",
            title: "Confirmation",
            badgeColor: "#0f766e",
            badgeBg: "#ecfdf5",
            borderColor: "#0f766e",
          },
          {
            key: "booking",
            title: "Scheduled",
            badgeColor: "#2563eb",
            badgeBg: "#eff6ff",
            borderColor: "#2563eb",
          },
        ].map((tpl, idx) => (
          <div
            key={tpl.key}
            style={{
              marginTop: idx === 0 ? "1rem" : "1.25rem",
              borderLeft: `4px solid ${tpl.borderColor}`,
              paddingLeft: "1rem",
              background: "#f8f9fa",
            }}
          >
            <Tag
              value={tpl.title}
              severity="info"
              style={{
                background: tpl.badgeBg,
                color: tpl.badgeColor,
                fontWeight: 700,
                marginBottom: ".5rem",
              }}
            />
            {meeting.templates[tpl.key] ? (
              <>
                <div style={{ fontWeight: 600 }}>
                  {meeting.templates[tpl.key].header || "-"}
                </div>

                <div style={{ fontWeight: 600, whiteSpace: "pre-wrap" }}>
                  {meeting.templates[tpl.key].body || "-"}
                </div>

                {meeting.templates[tpl.key].footer && (
                  <>
                    <div>{meeting.templates[tpl.key].footer}</div>
                  </>
                )}
              </>
            ) : (
              <span>Not selected</span>
            )}
          </div>
        ))}
      </Card>

      {/* ───── Ready banner ───── */}
      <div
        style={{
          border: "1px solid #22C55E",
          borderRadius: 8,
          background: "#ECFDF5",
          padding: "1rem 1.25rem",
          marginBottom: "1.5rem",
          display: "flex",
          alignItems: "flex-start",
          gap: 12,
        }}
      >
        <i
          className="pi pi-check-circle"
          style={{ color: "#16A34A", fontSize: 20, marginTop: 2 }}
        />
        <div>
          <h4 style={{ margin: 0, color: "#16A34A", fontWeight: 700 }}>
            Ready to Schedule
          </h4>
          <p style={{ margin: "4px 0 0", lineHeight: 1.5, color: "#111827" }}>
            Your meeting <strong>"{meeting.title}"</strong> is ready to be
            scheduled. All participants will receive automated messages
            according to your selected templates. Click{" "}
            <em>“Schedule Meeting”</em> to confirm and send initial
            notifications.
          </p>
        </div>
      </div>
    </div>
  );
}
